import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
// import useMedia from "../../../services/chat/useMedia";
import useMedia from "../../../services/Whatsapp/useMedia";
const SendTemplateModal = ({
  show,
  onClose,
  whatsappNumbers,
  SingleWhatsApp,
  templates,
  fetchVendorTemplates,
  executeTemplate,
  userID,
}) => {
  const { uploadImage, uploadVideo, uploadDocument } = useMedia();

  // const { sendMedia } = useMedia();

  const [mobile, setMobile] = useState("");
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [headerFormat, setHeaderFormat] = useState("");
  const [mediaUrl, setMediaUrl] = useState("");
  const [uploading, setUploading] = useState(false);
  const [localWhatsApp, setLocalWhatsApp] = useState("");

  /* ───────── reset modal ───────── */

  useEffect(() => {
    if (show) {
      setMobile("");
      setSelectedTemplate("");
      setHeaderFormat("");
      setMediaUrl("");
      setUploading(false);
      setLocalWhatsApp(SingleWhatsApp);
    }
  }, [show, SingleWhatsApp]);

  useEffect(() => {
    if (localWhatsApp) {
      fetchVendorTemplates(localWhatsApp);
    }
  }, [localWhatsApp]);

  if (!show) return null;

  const handleTemplateChange = (value) => {
    setSelectedTemplate(value);
    const tpl = templates.find((t) => t.name === value);
    const header = tpl?.components?.find((c) => c.type === "HEADER");

    if (header) {
      setHeaderFormat(header.format);
    } else {
      setHeaderFormat("");
    }
    setMediaUrl("");
  };

  /* ───────── upload media ───────── */

  const handleFileUpload = async (file) => {
    if (!file) return;

    try {
      setUploading(true);
      /* IMAGE UPLOAD */

      if (headerFormat === "IMAGE") {
        const reader = new FileReader();

        reader.onload = async () => {
          const base64 = reader.result.split(",")[1];
          const res = await uploadImage(file.name, base64);
          if (res?.status === "0") {
            const url = res?.image_url;
            setMediaUrl(url);
            toast.success("Image uploaded successfully");
          } else {
            toast.error("Image upload failed");
          }
        };

        reader.readAsDataURL(file);
      } else if (headerFormat === "VIDEO") {

      /* VIDEO UPLOAD */
        const res = await uploadVideo(file);
        if (res?.responseCode === "00") {
          const url = res?.data?.mediaUrl;
          setMediaUrl(url);
          toast.success("Video uploaded successfully");
        } else {
          toast.error(res?.responseMessage || "Video upload failed");
        }
      } else if (headerFormat === "DOCUMENT") {

      /* DOCUMENT UPLOAD */
        const res = await uploadDocument(file);

        if (res?.responseCode === "00") {
          const url = res?.data?.mediaUrl;
          setMediaUrl(url);
          toast.success("Document uploaded successfully");
        } else {
          toast.error(res?.responseMessage || "Document upload failed");
        }
      }
    } catch (err) {
      console.error("Upload error:", err);

      toast.error("Upload failed");
    } finally {
      setUploading(false);
    }
  };

  /* ───────── send template ───────── */

  const handleSend = () => {
    if (!mobile || !selectedTemplate) {
      toast.error("Enter mobile & template");
      return;
    }

    const tpl = templates.find((t) => t.name === selectedTemplate);

    const header = tpl?.components?.find((c) => c.type === "HEADER");

    if (header && !mediaUrl) {
      toast.error("Upload media first");
      return;
    }

    const payload = {
      userid: userID,

      contacts: [`91${mobile}`],

      templateId: tpl.id,

      templateName: tpl.name,

      type: tpl.category,

      languageCode: tpl.language,

      format: header?.format?.toLowerCase() || "text",

      messaging_product: "whatsapp",

      execute_type: "N",

      secret: "N",

      headerParams:
        headerFormat === "IMAGE" ||
        headerFormat === "VIDEO" ||
        headerFormat === "DOCUMENT"
          ? [mediaUrl]
          : [],

      bodyParams: [],

      footerParams: [],
    };
    executeTemplate(payload);
    onClose();
  };

  return (
    <>
<ToastContainer/>
    <div
      className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 montserrat-font-1"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-lg w-[650px] shadow-lg montserrat-font-1"
        onClick={(e) => e.stopPropagation()}
      >
        {/* HEADER */}

        <div className="flex justify-between items-center border-b px-5 py-3 montserrat-font-1">
          <h2 className="text-lg font-semibold">Send Template to New Number</h2>

          <div className="flex items-center gap-3 montserrat-font-1">
            <select
              value={localWhatsApp}
              onChange={(e) => setLocalWhatsApp(e.target.value)}
              className="bg-gray-100 border rounded-md px-3 py-1 text-sm"
            >
              {whatsappNumbers?.map((n) => (
                <option key={n.phone_no_id} value={n.phone_no_id}>
                  {n.phone_no_id} — ({n.phone_no})
                </option>
              ))}
            </select>

            <button
              onClick={onClose}
              className="text-gray-500 hover:text-black text-xl"
            >
              ×
            </button>
          </div>
        </div>

        {/* BODY */}

        <div className="p-5 space-y-5 montserrat-font-1">
          {/* MOBILE */}

          <div className="montserrat-font-1">
            <label className="text-sm font-medium">Customer Mobile</label>

            <input
              type="text"
              autoComplete="off"
              name="sendTemplateMobile"
              placeholder="Enter mobile (with or without country code)"
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
              className="w-full border rounded-md px-3 py-2 mt-1 text-sm focus:outline-none focus:ring-2 focus:ring-green-500"
            />
          </div>

          {/* TEMPLATE */}

          <div>
            <label className="text-sm font-medium">Template</label>

            <select
              value={selectedTemplate}
              onChange={(e) => handleTemplateChange(e.target.value)}
              className="w-full border rounded-md px-3 py-2 mt-1 bg-gray-100 text-sm"
            >
              <option value="">Select template</option>

              {templates?.map((tpl) => (
                <option key={tpl.id} value={tpl.name}>
                  {tpl.name} — {tpl.category}
                </option>
              ))}
            </select>
          </div>

          {/* HEADER MEDIA */}

          {headerFormat && headerFormat !== "TEXT" && (
            <div>
              <label className="text-sm font-medium">
                Header media required:
                <span className="font-semibold ml-1">{headerFormat}</span>
              </label>

              <input
                type="file"
                accept={
                  headerFormat === "IMAGE"
                    ? "image/png,image/jpeg,image/jpg"
                    : headerFormat === "VIDEO"
                      ? "video/mp4"
                      : ".pdf,.doc,.docx"
                }
                onChange={(e) => handleFileUpload(e.target.files[0])}
                className="mt-2 block w-full text-sm"
              />

              {uploading && (
                <p className="text-xs text-gray-500 mt-1">Uploading...</p>
              )}
            </div>
          )}
        </div>

        {/* FOOTER */}

        <div className="flex justify-end gap-3 border-t px-5 py-3">
          <button
            onClick={onClose}
            className="px-4 py-1.5 rounded-md border text-sm"
          >
            Close
          </button>

          <button
            onClick={handleSend}
            className="px-4 py-1.5 rounded-md bg-green-500 text-white text-sm hover:bg-green-600"
          >
            Send
          </button>
        </div>
      </div>
    </div>
    </>
  );
};

export default SendTemplateModal;
